export default __webpack_public_path__ + "static/media/variation_of_orders.fa53860f.svg";